export default __webpack_public_path__ + "_/shared_modules/sprites/dist/sprite-k12-banner-family@2x-59cb80b00225c93d8dd0a2418c91bba1.png";